export default __webpack_public_path__ + "static/10-ba354a5c010fcd00f468966dd9853276.png";